// src/App.jsx
import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import EquipmentPage from './pages/EquipmentPage';
import EmployeesPage from './pages/EmployeesPage';
import LoginPage from './pages/LoginPage'; // <-- Страница с формой логина (опционально)

function App() {
  const API_URL = process.env.REACT_APP_API_URL;

  // Храним авторизацию «наверхнем» уровне
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);

  // При загрузке проверяем токен
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Проверяем его через /check-token
      fetch(`${API_URL}/check-token`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error('Токен недействителен');
          return res.json();
        })
        .then((data) => {
          setIsAuthenticated(true);
          setUserRole(data.role);
        })
        .catch((err) => {
          console.error(err);
          localStorage.removeItem('token');
          setIsAuthenticated(false);
          setUserRole(null);
        });
    }
  }, [API_URL]);

  // Логин (вместо handleLogin внутри EquipmentPage)
  const handleLogin = (username, password) => {
    fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          localStorage.setItem('token', data.token);
          localStorage.setItem('currentUserRole', data.role);
          setIsAuthenticated(true);
          setUserRole(data.role);
        } else {
          alert('Ошибка входа: ' + data.message);
        }
      })
      .catch((error) => console.error('Ошибка при логине:', error));
  };

  // Логаут (вместо handleLogout внутри EquipmentPage)
  const handleLogout = () => {
    const token = localStorage.getItem('token');
    fetch(`${API_URL}/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.ok) {
          // Убираем из localStorage
          localStorage.removeItem('token');
          localStorage.removeItem('currentUserRole');
          setIsAuthenticated(false);
          setUserRole(null);
        } else {
          console.error('Ошибка при выходе');
        }
      })
      .catch((err) => console.error('Ошибка при выходе:', err));
  };

  return (
      <div>
        <nav>
          {/* Пример меню */}
          {isAuthenticated && (
            <>
              <Link to="/" style={{ marginRight: 12 }}>Оборудование</Link>
              <Link to="/employees" style={{ marginRight: 12 }}>Сотрудники</Link>
              <button onClick={handleLogout}>Выйти</button>
            </>
          )}
        </nav>

        <Routes>
          {/* Страница логина (если нужна) */}
          <Route
            path="/login"
            element={
              isAuthenticated
                ? <Navigate to="/" />
                : <LoginPage onLogin={handleLogin} />
            }
          />

          {isAuthenticated ? (
            <>
              {/* Когда авторизован, даём доступ к EquipmentPage, EmployeesPage */}
              <Route
                path="/"
                element={<EquipmentPage userRole={userRole} API_URL={API_URL} />}
              />
              <Route
                path="/employees"
                element={<EmployeesPage userRole={userRole} API_URL={API_URL} />}
              />

              {/* Любой другой путь -> на главную */}
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : (
            <>
              {/* Если не авторизован, отправляем на /login */}
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
        </Routes>
      </div>
  );
}

export default App;
